module.exports = __webpack_public_path__ + "img/10875_L.c717e7f8.png";